var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOetangSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.868,
    height: 28.346,
    viewBox: "0 0 27.868 28.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5a713e;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-1",
    d: "M0,0H27.868V-28.346H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(0 28.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210-2",
    "data-name": "Group 210",
    transform: "translate(26.501 -16.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-1",
    d: "M0,0A12.617,12.617,0,0,0-12.567-11.55,12.617,12.617,0,0,0-25.135,0,1.771,1.771,0,0,0-26.5,1.89,1.735,1.735,0,0,0-25.016,3.8a1.042,1.042,0,0,0,.125-.016A12.62,12.62,0,0,0-20,11.264,7.8,7.8,0,0,0-12.567,16.8a7.8,7.8,0,0,0,7.433-5.535A12.613,12.613,0,0,0-.244,3.779,1.033,1.033,0,0,0-.118,3.8,1.736,1.736,0,0,0,1.367,1.89,1.771,1.771,0,0,0,0,0M-6.065,6.449a7.079,7.079,0,0,1,.452,2.494,6.991,6.991,0,0,1-6.954,7.028,6.991,6.991,0,0,1-6.952-7.028,7.057,7.057,0,0,1,.452-2.494A4.478,4.478,0,0,1-21.9,2.285a4.48,4.48,0,0,1,4.48-4.48,4.48,4.48,0,0,1,4.464,4.12c.128-.007.257-.011.386-.011s.259,0,.388.011a4.479,4.479,0,0,1,4.464-4.12,4.479,4.479,0,0,1,4.478,4.48A4.478,4.478,0,0,1-6.065,6.449"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(13.561 -9.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-1",
    d: "M0,0S-1.189-1.188-1.683-.743-.6.346,0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(14.308 -9.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-1",
    d: "M0,0C.593.346,2.177-.3,1.683-.743S0,0,0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(12.746 -12.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-1",
    d: "M0,0A1.931,1.931,0,0,0-1.93-1.931,1.931,1.931,0,0,0-3.861,0,1.931,1.931,0,0,0-1.93,1.931a1.864,1.864,0,0,0,.261-.02A.69.69,0,0,1-2.2,1.239.694.694,0,0,1-1.51.545a.694.694,0,0,1,.693.694.685.685,0,0,1-.163.44A1.927,1.927,0,0,0,0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(17.052 -14.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-1",
    d: "M0,0A1.931,1.931,0,0,0-1.93,1.931,1.932,1.932,0,0,0-.952,3.609a.689.689,0,0,1-.161-.44A.692.692,0,0,1-.42,2.476a.693.693,0,0,1,.693.693.693.693,0,0,1-.535.673A2.058,2.058,0,0,0,0,3.862,1.931,1.931,0,0,0,1.931,1.931,1.93,1.93,0,0,0,0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(13.934 -5.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-1",
    d: "M0,0A1.205,1.205,0,0,0-1.2,1.2,1.206,1.206,0,0,0,0,2.409,1.206,1.206,0,0,0,1.2,1.2,1.205,1.205,0,0,0,0,0M0,1.639A.435.435,0,0,1-.435,1.2.436.436,0,0,1,0,.769.436.436,0,0,1,.435,1.2.435.435,0,0,1,0,1.639"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOetangSmall);
export default __webpack_public_path__ + "static/media/logo_oetang_small.3c8cb464c39b7e9e795331d37b7d9a50.svg";
export { ForwardRef as ReactComponent };